import { render, staticRenderFns } from "./SalsList.vue?vue&type=template&id=2a0b2734"
import script from "./SalsList.vue?vue&type=script&lang=js"
export * from "./SalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports